module.exports = __webpack_public_path__ + "static/media/placeholder.7c41e750.svg";